import script from "./NavTabs.vue?vue&type=script&setup=true&lang=js"
export * from "./NavTabs.vue?vue&type=script&setup=true&lang=js"

import "./NavTabs.vue?vue&type=style&index=0&id=675478e9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-675478e9"]])

export default __exports__